import React from 'react';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import {
  Box,Typography

} from "@mui/material";

function CarteInfoBureau(props) {
  return (
    
          
                <Card
                  sx={{
                    flex: 2,
                    maxWidth: 800,
                    // minWidth: { xs: "100%", md: 400 },
                    boxShadow: 3,
                    borderRadius: 3,
                    border: "1px solid #ddd",
                    mt: { xs: 3, md: 0 },
                    backgroundColor:'goldenrod'
                  }}
                >
                  <CardContent>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                        {props?.Bureau?.nom}
                      </Typography>
                      <Typography variant="subtitle1" color="text.secondary">
                        {props?.Bureau?.quartier}
                      </Typography>
                    </Box>
      
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      📍 {props?.Bureau?.adresse}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      📞 {props?.Bureau?.telephone}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      ✉️ {props?.Bureau?.email}
                    </Typography>
                  </CardContent>
                </Card>
    
  )
}

export default CarteInfoBureau
